module.exports = __webpack_public_path__ + "media/ctq-video-animations_ff.ab401198.mp4";